import { CardProps } from './props.js'

export function Card({
  variant = 'elevated',
  onClick,
  href,
  padded = true,
  className = '',
  children,
}: CardProps) {
  const baseClasses = [
    'rounded-lg border border-outline-variant transition-all interactive',
    'focus-visible:outline-2 focus-visible:outline-offset-2',
    padded && 'p-5',
  ].filter(Boolean)

  let variantClasses: string[] = []

  if (variant === 'elevated') {
    variantClasses = ['bg-surface-low']
  } else if (variant === 'filled') {
    variantClasses = ['bg-surface-container']
  } else if (variant === 'outlined') {
    variantClasses = ['bg-surface-container']
  }

  const finalClassName = [
    baseClasses.join(' '),
    variantClasses.join(' '),
    (onClick || href) && 'cursor-pointer hover:border-outline hover:bg-surface-high',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={finalClassName}
      >
        {children}
      </button>
    )
  }

  if (href) {
    return (
      <a
        href={href}
        className={finalClassName}
      >
        {children}
      </a>
    )
  }

  return <div className={finalClassName}>{children}</div>
}
